import React from "react";

type Props = {
    header: string;
    text: string;
}

const Instructions = ({ header, text }: Props) => {
    return (
        <div style={{ maxWidth: 360, position: 'absolute', bottom: 18, left: '50%', transform: 'translate(-30%, 0%)', display: 'flex', padding: '8px 12px', flexDirection: 'column', alignItems: 'flex-start', gap: 4, borderRadius: 8, background: "#FFF", boxShadow: '0px 4px 6px -1px rgba(0, 0, 0, 0.10), 0px 2px 4px -1px rgba(0, 0, 0, 0.06)' }}>
            <p style={{ margin: 0, fontSize: 14, fontWeight: 600, alignSelf: 'stretch', color: '#1A202C' }}>{header}</p>
            <p style={{ margin: 0, fontSize: 14, fontWeight: 400, alignSelf: 'stretch', color: '#222335' }}>{text}</p>
        </div>
    );
};

export default Instructions;